import { foldText } from './normalize.js';
export function slugify(text, maxLength = 80) {
    const slug = foldText(text)
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, maxLength)
        .replace(/-+$/g, '');
    return slug || 'item';
}
const ALPHABET = 'abcdefghijkmnpqrstuvwxyz23456789';
/** URL-safe random suffix for unlisted share links. Uses the platform RNG. */
export function randomSlugSuffix(length = 10, random = Math.random) {
    let out = '';
    for (let i = 0; i < length; i++)
        out += ALPHABET[Math.floor(random() * ALPHABET.length)];
    return out;
}
//# sourceMappingURL=slug.js.map